import * as API from '@/API'

const createState = () => ({
  isAuthenticated: false,
  myAccount: {},
  account: {},
  userList: [],
  isLoadingUser: false,
})

const actions = {
  getMyUserDetails: async ({ commit }) => {
    const results = await API.getUserSelf()
    commit('setMyAccount', results)
    commit('setIsAuthenticated')
  },
  getUser: async ({ state, commit }, uid) => {
    commit('setIsLoadingUser', true)
    const results = await API.getUser(uid)
    if (uid === state.myAccount.id) {
      commit('setMyAccount', results)
    } else {
      commit('setUser', results)
    }
    commit('setIsLoadingUser', false)
    return results
  },
  getUserList: async ({ commit }) => {
    const results = await API.getUserList()
    await commit('setUserList', results)
  },
  updateUserGroups: async ({ dispatch }, payload) => {
    await API.updateUserGroups(payload.userId, payload.groups)
    await dispatch('getUserList')
  },
  generateApiKey: async ({ dispatch }, payload) => {
    const result = await API.generateApiKey(payload.userId, payload.key)
    await dispatch('getUser', payload.userId)
    return result
  },
  deleteApiKey: async ({ dispatch }, payload) => {
    await API.deleteApiKey(payload.userId, payload.keyId)
    await dispatch('getUser', payload.userId)
  },
  changeTacacsPassword: async ({ dispatch }, payload) => {
    await API.changeTacacsPassword(payload.userId, payload.passwordHash)
    await dispatch('getUser', payload.userId)
  },
  updateSshKeys: async ({ dispatch }, payload) => {
    await API.updateSshKeys(payload.userId, payload.authorizedKeys)
    await dispatch('getUser', payload.userId)
  },
}

const getters = {
  userGroups(state) {
    return (state.myAccount.groups || []).filter(group => group.member).map(group => group.name.toLowerCase())
  },
  isCurrentUserAdmin(state) {
    return (state.myAccount.groups || []).some(group => {
      return group.name === 'Admin' && group.member
    })
  },
}

const mutations = {
  setUser: (state, data) => {
    state.account = data
  },
  setUserList: (state, data) => {
    state.userList = data
  },
  setIsAuthenticated: state => {
    state.isAuthenticated = true
  },
  setIsLoadingUser: (state, data) => {
    state.isLoadingUser = data
  },
  setMyAccount: (state, data) => {
    state.myAccount = data
  },
}

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state: createState(),
}
